<template>
  <div class="participante-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Código Promoción"
            v-if="solicitaCodigoPromocion">
          <b-form>
            <b-form-group
              label="Cod.Promoción"
              label-for="codigoPromocion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPromocion"
                :value="participante.codigoPromocion" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Sorteo" v-if="importaGanadores">
          <b-form>
            <b-form-group
              label="Posición"
              label-for="posicionSorteo"
              :label-cols="labelCols"
              description="Posición en el sorteo"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="posicionSorteo"
                  :value="participante.posicionSorteo" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-form>
          <template slot="footer">
            <small class="text-muted">Sorteo importado a partir de un archivo CSV</small>
          </template>  
        </b-card>

        <b-card header="Información del Participante">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaNombre"
              label="Nombre Completo"
              label-for="nombreCompleto"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreCompleto"
                :value="participante.nombreCompleto" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDatosPersonales"
              label="Fecha Nacimiento"
              label-for="fechaNacimiento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaNacimiento"
                :value="participante.fechaNacimiento | fecha" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDocumento"
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                :value="participante.documentoNumero" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDatosPersonales"
              label="Sexo"
              label-for="sexo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="sexo"
                :value="participante.sexo" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaEmail"
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                :value="participante.email" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaTelefono"
              label="Nro.Celular"
              label-for="numeroCelular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCelular"
                :value="participante.numeroCelular" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Provincia"
              label-for="provincia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="provincia"
                :value="participante.provincia" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaLocalidad"
              label="Localidad"
              label-for="localidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="localidad"
                :value="participante.localidad" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaBarrio"
              label="Barrio"
              label-for="barrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="barrio"
                :value="participante.barrio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                :value="participante.direccion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Cod.Postal"
              label-for="codigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPostal"
                :value="participante.codigoPostal" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoValidaNumeroCliente"
              label="Cliente Previo"
              label-for="clientePrevio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="clientePrevio"
                :value="participante.clientePrevio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoValidaNumeroCliente"
              label="Nro.Cliente"
              label-for="numeroCliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCliente"
                :value="participante.numeroCliente" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                :value="participante.observaciones" 
                rows="3"
                max-rows="3"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Información Bancaria"
            v-if="requiereInformacionBancaria">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco"
                :value="participante.banco" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                :value="participante.cbu" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                :value="participante.cbuAlias" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Titular"
              label-for="titularCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuenta"
                :value="participante.titularCuenta" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="CUIT"
              label-for="titularCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuit"
                :value="participante.titularCuit" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Información del Negocio"
            v-if="participacionNegocios">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaPosicionNegocio"
              label="Posición"
              label-for="posicion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="posicion"
                :value="participante.negocio.posicion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                :value="participante.negocio.nombreComercial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaRazonSocialNegocio"
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                :value="participante.negocio.razonSocial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDocumentoNegocio"
              label="CUIT"
              label-for="negocioCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCuit"
                :value="participante.negocio.cuit" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Pais"
              label-for="negocioPais"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioPais"
                :value="participante.negocio.pais" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Provincia"
              label-for="negocioProvincia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioProvincia"
                :value="participante.negocio.provincia" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaLocalidadNegocio"
              label="Localidad"
              label-for="negocioLocalidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioLocalidad"
                :value="participante.negocio.localidad" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaBarrioNegocio"
              label="Barrio"
              label-for="negocioBarrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioBarrio"
                :value="participante.negocio.barrio" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Direccion"
              label-for="negocioDireccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioDireccion"
                :value="participante.negocio.direccion" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Cod.Postal"
              label-for="negocioCodigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCodigoPostal"
                :value="participante.negocio.codigoPostal" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Campos Adicionales" v-if="tieneCamposAdicionales">
          <b-form>
            <!-- <template v-for="(campoAdicional, index) in participante.camposAdicionales" :key="index"> -->
              <b-form-group
                v-for="(campoAdicional, index) in participante.camposAdicionales" 
                :key="index"
                :label="campoAdicional.campo"
                :label-for="campoAdicional.id"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  :id="campoAdicional.id"
                  :value="campoAdicional.valor"
                  type="text"
                  readonly/>
              </b-form-group>
            <!-- </template> -->
          </b-form>
        </b-card>

        <b-card header="Validaciones de Identidad"
            v-if="validaIdentidad"
            class="card-filter">
          <b-btn class="filter-collapse" 
              variant="primary" 
              size="sm"
              @click.prevent="showValidacionesIdentidad= !showValidacionesIdentidad">
            <i :class="showValidacionesIdentidad ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-btn class="card-header-add" 
              v-if="showValidacionesIdentidad & !identidadValidada & !reinscripcion"
              variant="primary" 
              size="sm"
              @click.prevent="validarIdentidad">
            <i class="fa fa-plus"></i>
          </b-btn>
          
          <b-collapse class="mt-2" v-model="showValidacionesIdentidad">
            <template v-if="reinscripcion">
              <b-form>
                <b-form-group
                  label="Reinscripción"
                  label-for="reinscripcion"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="reinscripcion"
                    :value="validacionIdentidadReinscripcion.reinscripcion" 
                    type="text"
                    readonly/>
                </b-form-group>

                <b-form-group
                  label="Evento"
                  label-for="evento"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="evento"
                    :value="validacionIdentidadReinscripcion.evento" 
                    type="text"
                    readonly/>
                </b-form-group>

                <b-form-group
                  label="Fecha Validación"
                  label-for="fechaValidacion"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaValidacion"
                    :value="validacionIdentidadReinscripcion.fechaValidacion | fecha" 
                    type="text"
                    readonly/>
                </b-form-group>

                <b-form-group
                  label="Usuario"
                  label-for="usuarioValidacion"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="usuarioValidacion"
                    :value="validacionIdentidadReinscripcion.usuarioValidacion" 
                    type="text"
                    readonly/>
                </b-form-group>
              </b-form>
            </template>

            <template v-if="!reinscripcion">
              <b-table 
                  class="registro validaciones" 
                  responsive="sm" 
                  :items="validacionesIdentidad" 
                  :fields="fieldsValidaciones">
                <template v-slot:cell(fechaRegistro)="data">
                  {{ data.item.fechaRegistro | fechaHora }}
                </template>
                <template v-slot:cell(validacionAprobada)="data">
                  {{ data.item.validacionAprobada? 'Si' : 'No' }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <b-dropdown v-if="borrarHabilitado" variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="borrarValidacionIdentidad(data.item)">
                      <i class="fa fa-close"></i>Borrar Validación</b-dropdown-item>
                  </b-dropdown>
                </template>            

                <template v-slot:cell(detailShowing)="row">
                  <b-btn class="detailShowing" 
                      size="sm" 
                      v-if="row.item.observaciones != ''" 
                      @click.stop="row.toggleDetails">
                    {{ ( row.detailShowing) ? '-' : '+' }}
                  </b-btn>            
                </template>

                <template slot="row-details" slot-scope="row">
                  <b-row>
                    <b-col cols="12">
                      <p class="descripcion">{{ row.item.observaciones }}</p>
                    </b-col>
                  </b-row>
                </template>
              </b-table>
            </template>
          </b-collapse> 
        </b-card>

        <app-imagenes
          v-if="validaImagenes"
          ref="imagenes">
        </app-imagenes>

        <template v-if="tieneEtapas"> 
          <!-- <template v-for="{id, nombre} in evento.etapas" :key="id"> -->
          <div v-for="{id, nombre} in eventoEtapas" :key="id">
            <div  class="participante-evento-etapa-header">
              <b-btn 
                  v-if="isInscriptoEtapa(id)"
                  class="filter-collapse"
                  variant="primary" 
                  size="sm"
                  @click.prevent="consultarEtapa(id)">
                <i class="fa fa-caret-right"></i>
              </b-btn>
              <b-btn 
                  v-if="!isInscriptoEtapa(id)"
                  class="filter-collapse"
                  variant="primary" 
                  size="sm"
                  @click.prevent="agregarParticipanteEtapa(id)">
                <i class="fa fa-plus"></i>
              </b-btn>
              Etapa {{ nombre }}
            </div>
          </div>
        </template>

        <app-validaciones-participacion
          v-if="validaParticipacion & !tieneEtapas"
          ref="validacionesParticipacion">
        </app-validaciones-participacion>

        <app-transferencias
          v-if="transferenciasPremios & !tieneEtapas"
          ref="transferencias">
        </app-transferencias>
      </b-col>
    </b-row>

    <b-modal ref="validacionModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-validacion
        :eventoId="eventoId"
        :participanteId="participanteId"
        :validacionIdentidad="true"
        @close="closeValidacion">
      </app-validacion>  
    </b-modal>

    <div class="fixed-btn" v-if="!editarHabilitado">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <div class="fixed-btn" v-if="editarHabilitado">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editarParticipante" 
              v-if="editarHabilitado">
            <i class="fa fa-edit"></i>Editar Datos del Participante</b-dropdown-item>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ValidacionesParticipacion from  './ValidacionesParticipacion.vue';
import Transferencias from  './Transferencias.vue';
import Imagenes from  './Imagenes.vue';
import Validacion from  '../validaciones/ABM.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteDatos/getField',
  mutationType: 'participanteDatos/updateField',
});

export default {
  name: 'ParticipanteDatos',
  components: {
    appValidacionesParticipacion: ValidacionesParticipacion,
    appTransferencias: Transferencias,
    appImagenes: Imagenes,
    appValidacion: Validacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      fieldsValidaciones: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        {
          key: 'validacionAprobada',
          label: 'Aprobado'
        },
        {key: 'usuario'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      showValidacionesIdentidad: false,
      editarHabilitado: false,
      borrarHabilitado: false,
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'participanteId',

      'evento',
      'participante',

      'validacionesIdentidad',
      'validacionesParticipacion',
      'transferencias',
      'imagenes',
      'validacionIdentidadReinscripcion',
      'reinscripcion',
      
      // 'identidadValidada',
      // 'participacionValidada',
      'etapas'
    ]),
    validaIdentidad() {
      if (this.evento) {
        return (/true/i).test(this.evento.validaIdentidad);
      }

      return false;
    },
    identidadValidada() {
      if (this.validacionesIdentidad) {
        if (this.validacionesIdentidad.length != 0) {
          let identidadValidada = this.validacionesIdentidad
            .find(validacion => (/true/i).test(validacion.validacionAprobada));
          
          if (identidadValidada) {
            return true;
          }
        }
      }
      return false;
    },
    validaParticipacion() {
      if (this.evento) {
        return (/true/i).test(this.evento.validaParticipacion);
      }

      return false;
    },
    participacionValidada() {
      if (this.validacionesParticipacion) {
        if (this.validacionesParticipacion.length != 0) {
          let participacionValidada = this.validacionesParticipacion
            .find(validacion => (/true/i).test(validacion.validacionAprobada));
          
          if (participacionValidada) {
            return true;
          }
        }
      }
      return false;
    },
    validaImagenes() {
      if (this.evento) {
        return (/true/i).test(this.evento.validaImagenes);
      }

      return false;
    },
    transferenciasPremios() {
      if (this.evento) {
        return (/true/i).test(this.evento.transferenciasPremios);
      }
      return false;
    },
    participacionNegocios() {
      if (this.evento) {
        return (/true/i).test(this.evento.participacionNegocios);
      }
      return false;
    },
    requiereInformacionBancaria() {
      if (this.evento) {
        return (/true/i).test(this.evento.requiereInformacionBancaria);
      }
      return false;
    },
    solicitaCodigoPromocion () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaCodigoPromocion);
      }
      return false;
    },
    importaGanadores () {
      if (this.evento) {
        return (/true/i).test(this.evento.importaGanadores);
      }
      return false;
    },
    tieneEtapas () {
      if (this.evento) {
        if (this.evento.etapas) {
          return this.evento.etapas.length != 0;
        }
      }
      return false;
    },
    eventoEtapas() {
      if (this.evento) {
        if (this.evento.etapas) {
          return this.evento.etapas.slice().reverse();
        }
      }
      return [];
    },
    tieneCamposAdicionales () {
      if (this.participante) {
        if (this.participante.camposAdicionales) {
          return this.participante.camposAdicionales.length != 0;
        }
      }
      return false;
    },
    eventoSolicitaNombre () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaNombre);
      }
      return false;
    },
    eventoSolicitaDocumento () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaDocumento);
      }
      return false;
    },
    eventoSolicitaUbicacion () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaUbicacion);
      }
      return false;
    },
    eventoSolicitaLocalidad () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaLocalidad);
      }
      return false;
    },
    eventoSolicitaBarrio () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaBarrio);
      }
      return false;
    },
    eventoSolicitaDatosPersonales () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaDatosPersonales);
      }
      return false;
    },
    eventoSolicitaTelefono () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaTelefono);
      }
      return false;
    },
    eventoSolicitaEmail () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaEmail);
      }
      return false;
    },
    eventoValidaNumeroCliente () {
      if (this.evento) {
        return (/true/i).test(this.evento.validaNumeroCliente);
      }
      return false;
    },
    eventoSolicitaPosicionNegocio() {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaPosicionNegocio);
      }
      return false;
    },
    eventoSolicitaRazonSocialNegocio() {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaRazonSocialNegocio);
      }
      return false;
    },
    eventoSolicitaDocumentoNegocio() {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaDocumentoNegocio);
      }
      return false;
    },
    eventoSolicitaUbicacionNegocio() {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaUbicacionNegocio);
      }
      return false;
    },
    eventoSolicitaLocalidadNegocio () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaLocalidadNegocio);
      }
      return false;
    },
    eventoSolicitaBarrioNegocio () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaBarrioNegocio);
      }
      return false;
    },
  },
  created() {
    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.editarHabilitado = true;
      this.borrarHabilitado = true;
    }

    let eventoId = 0;
    let participanteId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.id){
        participanteId = this.$route.params.id;
      }
    }

    let params = {
      eventoId,
      participanteId
    }

    this.showSpinner();
    this.$store.dispatch('participanteDatos/getDatos', params)
      .then(() => {
        if ((/true/i).test(this.validaIdentidad)) {
          this.$store.dispatch('participanteDatos/getValidacionesIdentidad');
        }
        if ((/true/i).test(this.validaParticipacion)) {
          this.$store.dispatch('participanteDatos/getValidacionesParticipacion');
        }
        if ((/true/i).test(this.validaImagenes)) {
          this.$store.dispatch('participanteDatos/getImagenes');
        }

        this.$store.dispatch('participanteDatos/getTransferencias');
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    isInscriptoEtapa(etapaId) {
      if (this.etapas) {
        if (this.etapas.length != 0) {
          let participanteEtapa = this.etapas.find(t => t.eventoEtapaId == etapaId);
          
          if (participanteEtapa != null) {
            return true;
          }
        }
      }
      return false;
    },
    consultarEtapa(etapaId) {
      this.$router.push({ name: 'ParticipanteEtapa',
                          params: { 
                            eventoId: this.eventoId, 
                            id: this.participanteId,
                            eventoEtapaId: etapaId
                          }});
    },
    agregarParticipanteEtapa(etapaId) {
      if (!(/true/i).test(this.reinscripcion)) {
        this.showModalConfirm('¿Desea inscribir el participante en la etapa seleccionada?', 
          this.agregarParticipanteEtapaSeleccionada.bind(this, etapaId), 'Si', null, 'No')
      }
    }, 
    agregarParticipanteEtapaSeleccionada(etapaId) {
      this.showSpinner();
      this.$store.dispatch('participanteDatos/addParticipanteEventoEtapa', etapaId)
        .then(() => this.showModalMsj('La inscripción se registró con éxito.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    }, 
    goBack() {
      this.$router.go(-1);
    },
    validarIdentidad() {
      if (!(/true/i).test(this.reinscripcion)) {
        this.$refs.validacionModal.show();
      }
    },
    closeValidacion(saved) {
      this.$refs.validacionModal.hide();
      if (saved) {
        this.$store.dispatch('participanteDatos/getValidacionesIdentidad')
          .catch( error => this.showErrorMsj (error));
      }
    },
    borrarValidacionIdentidad(item) {
      if (!(/true/i).test(this.reinscripcion)) {
        this.showModalConfirm('¿Desea borrar la validación seleccionada?', 
          this.borrarValidacionIdentidadSeleccionada.bind(this, item.id), 'Si', null, 'No')
      }
    }, 
    borrarValidacionIdentidadSeleccionada(validacionId) {
      this.showSpinner();
      this.$store.dispatch('participanteDatos/deleteValidacionIdentidad', validacionId)
        .then(() => {
          this.showModalMsj('La validación seleccionada se borró con éxito.', null, null, 'light')
          this.$store.dispatch('participanteDatos/getValidacionesIdentidad');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    editarParticipante () {
      this.$router.push({ name: 'ParticipanteEdit', 
                          params: { 
                            eventoId: this.eventoId, 
                            id: this.participanteId
                          }});
    },
  },
  watch: {
    'files' : function(newVal, oldVal) {
      this.uploadFiles();
    },    
  }   
}
</script>

<style>
  /* .participante-datos .datos-objeto table td[aria-colindex="1"] {
    width: 20%;
  }
  .participante-datos .datos-objeto table td[aria-colindex="2"] {
    width: 80%;
  } */

  .registro.validaciones table th {
    border-top: none;
  }
  .registro.validaciones table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .registro.validaciones table td[aria-colindex="1"] {
    width: 40px;
  }
  .registro.validaciones table td[aria-colindex="1"] button {
    position: relative;
    top: -5px;
  }
  .registro.validaciones table td[aria-colindex="2"] {
    width: 20%;
  }
  .registro.validaciones table td[aria-colindex="3"] {
    width: 10%;
  }
  .registro.validaciones table td[aria-colindex="4"] {
    width: calc(70% - 100px);
  }
  .registro.validaciones table td[aria-colindex="5"] {
    width: 60px;
  }

  .registro.validaciones table p.descripcion {
    margin-bottom: 5px;
    padding-left: 40px;
    width: calc(90% - 40px);
    white-space: pre-wrap;
  }

  .participante-evento-etapa-header {
    width: 100%;
    margin-bottom: 20px;

    padding: 0.75rem 1.25rem;
    padding-left: 0;
    
    background-color: #f0f3f5;
    border-bottom: 1px solid #c8ced3;

    border: 1px solid #c8ced3;
    border-radius: 0.25rem;    
    /* cursor: pointer; */
    /* background-color: blue; */
  }
  .participante-evento-etapa-header .filter-collapse {
    position: relative;
    top: 0;
    left: 98%;
  }

</style>